module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Rose Gold + Lavender Closed.ac3f180e.png";